import React from 'react';

function FloatingAlert({ message, show, error, handleClose }) {
  if (!show) return null;

  const isError = error !== null && error !== undefined;

  return (
    <div
      className={`alert ${isError ? 'alert-danger' : 'alert-success'} alert-dismissible fade show`}
      role="alert"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        minWidth: '250px',
      }}
    >
      {isError ? error.message || 'Terjadi kesalahan.' : message}
      <button
        type="button"
        className="btn-close"
        onClick={handleClose}
        aria-label="Close"
      ></button>
    </div>
  );
}

export default FloatingAlert;
